module.exports = __webpack_public_path__ + "img/coupons.3e2650a3.svg";